<template>
    <div class="menu-button-container">
        <button class="draggable-item-menu-btn draggable-item-menu-btn-blue draggable-item-menu-btn-split-merge" @click="openModal">
            Dividir
        </button>
        <transition name="slide-fade">
            <SplitOrderReferenceButtonActionModal 
                v-if="showModal"
                :orderReference="orderReference" 
                :endOfAction="endOfAction" 
                :closeModal="closeModal" 
            />
        </transition>
    </div>
</template>

<script>
import SplitOrderReferenceButtonActionModal from './SplitOrderReferenceButtonActionModal.vue';


export default {
    name: "SplitOrderReferenceButton",
    components: {
        SplitOrderReferenceButtonActionModal
    },
    props: {
        orderReference: {
            type: Object,
            required: true
        },
        endOfAction: {
            type: Function,
            required: true
        },
    },
    data() {
        return {
            showModal: false,
        }
    },
    methods: {
        openModal() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
    },
};
</script>